var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
import { ListItem as CharkaListItem, OrderedList as ChakraOrderedList, UnorderedList as ChakraUnorderedList, } from "@chakra-ui/react";
/**
 * The list component. <ul> or <ol>.
 */
const List = forwardRef((_a, ref) => {
    var { className, isOrdered, children } = _a, rest = __rest(_a, ["className", "isOrdered", "children"]);
    const Component = isOrdered ? ChakraOrderedList : ChakraUnorderedList;
    return (React.createElement(Component, Object.assign({ className: className }, rest, { ref: ref }), children));
});
List.displayName = "List";
/**
 * The list item component. <li>.
 */
export const ListItem = forwardRef((props, ref) => {
    return React.createElement(CharkaListItem, Object.assign({}, props, { ref: ref }));
});
ListItem.displayName = "ListItem";
export default List;
//# sourceMappingURL=List.js.map